import DataTable from '../DataTable';
import { Row } from './styled';
import type { ScaleOrdinal } from 'd3-scale';

export interface Props {
  title: string;
  keys: string[];
  color: ScaleOrdinal<string, string>;
  entities: Record<string, number | null>;
  entityTitles: Record<string, string>;
  formatter: (value: number | null, significance?: number) => string;
}

const TooltipTable = ({
  title,
  keys,
  entities,
  entityTitles,
  color,
  formatter,
}: Props) => {
  return (
    <DataTable width="240px">
      <thead>
        <tr>
          <th colSpan={2}>{title}</th>
        </tr>
      </thead>
      <tbody>
        {keys.map((key) => (
          <Row key={`gauge-label-${key}-${entities[key]}`} color={color(key)}>
            <td>{entityTitles[key]}</td>
            <td>{formatter(entities[key], 1)}</td>
          </Row>
        ))}
      </tbody>
    </DataTable>
  );
};

export default TooltipTable;
